module.exports = __webpack_public_path__ + "static/media/cyrano-logo.3b410884.svg";